function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import styled from "styled-components";
import { StyledButtonBase, Icon } from "../";
export const ButtonIcon = /*#__PURE__*/forwardRef((props, ref) => (({
  name = "",
  type = "tertiary",
  active,
  forwardRef,
  ...props
}) => /*#__PURE__*/React.createElement(StyledButtonIcon, _extends({
  variant: type,
  active: active
}, props, {
  ref: forwardRef
}), /*#__PURE__*/React.createElement(StyledIcon, {
  tertiary: true,
  name: name
})))({ ...props,
  forwardRef: ref
}));
const StyledButtonIcon = styled(StyledButtonBase)`
  ${props => props.theme.buttonIcon[props.variant]};
  &:not(:disabled):hover,
  &:not(:disabled):focus {
    ${props => props.theme.buttonIcon[props.variant].hover};
  }
  ${props => props.active && props.theme.buttonIcon[props.variant].active};
  &:disabled {
    ${props => props.theme.buttonIcon[props.variant].disabled};
  }
`;
const StyledIcon = styled(Icon)`
  width: 22px;
  height: 22px;
`;